module.exports = __webpack_public_path__ + "static/media/banner_sp.39ab7aa7.jpg";